import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureFlagState } from '../actions/feature-flag.actions';

const selectFeatureFlagFeatureState = createFeatureSelector<FeatureFlagState>('featureFlags');
export const selectAllFeatureFlags = createSelector(selectFeatureFlagFeatureState, (state: FeatureFlagState) => state.enabledFeatures);
